module.exports = __webpack_public_path__ + "media/images/pc/specials/common/event_detail_try_on_dress-635679d9f7982e4a3dbdbe6b46ca33d4.jpg";